module.exports = __webpack_public_path__ + "static/media/2025_Sermeq_Helicopters_A_S.e8ff108a.png";